export const OVERLAY_OPEN_TIMEOUT = 0;
export const OVERLAY_CLOSE_TIMEOUT = 600;
